import React from 'react';
import { Dropdown, Menu } from 'antd';
import _isEmpty from 'lodash/isEmpty';
import classNames from 'classnames';

import { Fleet } from '../priority-configuration';

interface Props {
	fleets: Fleet[];
	onChange: (fleetId: string) => void;
	translations: Translations;
	disabled?: boolean;
}

export interface Translations {
	noMoreFleetsToAdd: string;
	addFleet: string;
}

const AddFleet: React.FC<Props> = ({ fleets, onChange, translations, disabled }) => {
	const onClick = ({ key }) => {
		onChange(key);
	};

	const overlay = _isEmpty(fleets) ? (
		<div
			style={{
				backgroundColor: 'white',
				padding: 10,
				borderRadius: 4,
				boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)'
			}}
		>
			{translations.noMoreFleetsToAdd}
		</div>
	) : (
		<Menu onClick={onClick}>
			{fleets.map(fleet => (
				<Menu.Item key={fleet.id}>{fleet.name}</Menu.Item>
			))}
		</Menu>
	);

	return (
		<Dropdown overlay={overlay} disabled={disabled} className="add-fleet">
			<span className={classNames('ant-dropdown-link', { disabled })} onClick={e => e.preventDefault()}>
				{`+  ${translations.addFleet}`}
			</span>
		</Dropdown>
	);
};

export default AddFleet;
